import Block 	from 'Mixins/Block';

export default Block('component-list-filter', {
	fn: {
		toggleFilterContainer (e) {
			e.preventDefault();
			const parent = this.parentNode;
			const expander = parent.querySelector('[data-filter-expander]');
			expander.classList.toggle('active');
			parent.classList.toggle('active');
			this.classList.toggle('active');
			this.querySelector('span').innerText = parent.classList.contains('active') ? 'Dölj filtrering' : 'Visa filtrering';
		},
		removeActiveFilter (filterlabel, _this) {
			const blockcontainer 	= document.querySelector(_this.selector);
			const expander 			= blockcontainer.querySelector('[data-filter-expander]');
			const form              = blockcontainer.querySelector('form');
			const id = filterlabel.getAttribute('data-filter-id');
			let activeCheckboxes = document.querySelectorAll('input[type="checkbox"]:checked');
			activeCheckboxes = Array.from(activeCheckboxes);
			activeCheckboxes.forEach( function(cb) {
				if(cb.getAttribute('id') === id) {
					cb.checked = false;
				}
			});
			filterlabel.parentNode.removeChild(filterlabel);
			_this.fn.noticeMe();
			if(expander && expander.classList.contains('active')) { return; }
			_this.fn.submitForm(form);
		},
		displayActiveFilters( checkbox, filterContainer, isClicked, _this ) {
			const parent = checkbox.parentNode;
			const labelText = parent.querySelector('label').innerText;
			const activeFilter = document.createElement('span');
			activeFilter.setAttribute('data-filter-id', checkbox.getAttribute('id'));
			activeFilter.textContent = labelText;
			activeFilter.addEventListener('click', function(){
				_this.fn.removeActiveFilter(this, _this);
			});
			filterContainer.appendChild(activeFilter);
			filterContainer.parentNode.classList.remove('empty');
			if( isClicked) {
				this.noticeMe();
			}
		},
		removeActiveLabel(checkbox, filterContainer){
			const labels = filterContainer.querySelectorAll('span');
			labels.forEach( function(label) {
				if(label.getAttribute('data-filter-id') === checkbox.getAttribute('id')) {
					label.parentNode.removeChild(label);
				}
			});
			this.noticeMe();
		},
		submitForm(formelement) {
			formelement.submit();
		},
		noticeMe() {
			const button = document.querySelector('[data-submit]');
			if(!button) { return; }
			if(button.classList.contains('notice-me')) { return; }
			button.classList.add('notice-me');
			setTimeout( function(){
				button.classList.remove('notice-me');
			}, 4000);
		},
		createArray(arr) {
			return Array.from(arr);
		}
	},
	onLoad () {
		const _this             = this;
		const container         = document.querySelector( _this.selector );
		if(!container){ return; }
		const filterToggler     = container.querySelector('[data-togglefilter]');
		const activeFilters     = container.querySelector('.active-filters');
		const filterCheckboxes  = this.fn.createArray(container.querySelectorAll('input[type="checkbox"].filter'));
		const activeCheckboxes  = this.fn.createArray(container.querySelectorAll('input[type="checkbox"].filter:checked'));
		const submitButton      = container.querySelector('[data-submit]');
		const resetButton       = container.querySelector('[data-reset]');
		const form              = container.querySelector('form');
		const autopost          = container.querySelector('[data-autopost]');
		const sorttriggers 		= this.fn.createArray(container.querySelectorAll('[data-sort]'));
		const sortvalue			= container.querySelector('[data-sortvalue]');
		if(filterToggler) {
			filterToggler.addEventListener('click', _this.fn.toggleFilterContainer);
		}
		if( submitButton && form) {
			submitButton.addEventListener('click', function(){
				_this.fn.submitForm(form);
			});
		}
		if( resetButton ) {
			resetButton.addEventListener('click', function(){
				activeFilters.textContent = '';
				activeCheckboxes.forEach( function(cb){
					cb.checked = false;
				});
				_this.fn.submitForm(form);
			});
		}
		if(filterCheckboxes) {
			filterCheckboxes.forEach( function( cb ) {
				cb.addEventListener('click', function(event) {
					var target = event.target || event.srcElement;
					if(target.checked) {
						_this.fn.displayActiveFilters( target, activeFilters, true, _this);
					} else {
						_this.fn.removeActiveLabel(target, activeFilters);
					}
				});
			});
		}
		if(activeCheckboxes){
			activeCheckboxes.forEach( function(cb) {
				_this.fn.displayActiveFilters( cb, activeFilters, false, _this );
			});
		}
		if(autopost){
			autopost.addEventListener('click', function(){
				_this.fn.submitForm(form);
			});
		}
		if(sorttriggers) {
			sorttriggers.forEach( function(trigger) {
				trigger.addEventListener('click', function(event){
					event.preventDefault();
					var target = event.target || event.srcElement;
					if(target.getAttribute('data-sort') === 'true') {
						sortvalue.checked = true;
					} else {
						sortvalue.checked = false;
					}
					_this.fn.submitForm(form);
				});
			});
		}
	}

});